import { API_ENDPOINTS } from '@utils/endpoints';
import { BaseService } from '../baseService';

// Model
import {
  CheckoutDetails,
  InvoiceResponse,
  SendEmailRequestPayload,
  SendEmailResponse,
  CheckoutResponse,
  APIResponse,
  RetryPaymentPayload,
} from '../models/Invoice';

export class InvoiceService {
  /**
   * @function fetchInvoiceList
   * @returns InvoiceResponse
   */
  static fetchInvoiceList = async (): Promise<InvoiceResponse> => {
    const response = await BaseService.post(API_ENDPOINTS.GET_INVOICE);
    return response as InvoiceResponse;
  };

  /**
   * @function sendMailDocument
   * @returns
   */
  static sendMailDocument = async (
    sendEmailRequestPayload: SendEmailRequestPayload
  ): Promise<SendEmailResponse> => {
    const response = await BaseService.post(API_ENDPOINTS.MAIL_DOCUMENT, sendEmailRequestPayload);
    return response as SendEmailResponse;
  };

  /**
   * @function postCheckoutDetails
   * @param action ProductTypePayload
   * @returns ProductFieldMappingResponse
   */
  static postCheckoutDetails = async (
    payload: CheckoutDetails
  ): Promise<APIResponse<CheckoutResponse>> => {
    const response = await BaseService.post(API_ENDPOINTS.CHECKOUT, payload);
    return response as APIResponse<CheckoutResponse>;
  };

  /**
   * @function retryPayment
   * @param payload RetryPaymentPayload
   * @returns
   */
  static retryPayment = async (
    payload: RetryPaymentPayload
  ): Promise<APIResponse<CheckoutResponse>> => {
    const response = await BaseService.post(API_ENDPOINTS.RETRY_PAYMENT, payload);
    return response as APIResponse<CheckoutResponse>;
  };
}
